import PropTypes from 'prop-types';
import React from 'react';
import loadable from '@loadable/component';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { withRouter } from '@bibliocommons/utils-routing';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { libraryShape, didNotFindOptionsShape, routerShape } from '@bibliocommons/bc-prop-types';
import { currentUserSelector } from '../selectors/AuthSelector';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import SearchActions from '../actions/SearchActions';

const EmptySearchResult = loadable(() => import('../components/search/EmptySearchResult'));

/** @extends React.Component */
class EmptySearchResultContainer extends BcReactComponent {
  render() {
    const {
      query,
      titleKey,
      activeFilters,
      chatWidgets,
      didYouMeanQuerySuggestion,
      didYouMeanResultCount,
      hasStaticEmptySearchResults,
      broadened,
      broadenedSearchType,
      searchType,
      showExternalSearchLink,
      rssURL,
      customEdit,
      suppress,
      orderedSearchTypes,
      didNotFindOptions,
      library,
      singleBranch,
      router,
      currentUser,
      shelfName
    } = this.props;

    return (
      <EmptySearchResult
        query={query}
        titleKey={titleKey}
        activeFilters={activeFilters}
        chatWidgets={chatWidgets}
        currentUser={currentUser}
        didYouMeanQuerySuggestion={didYouMeanQuerySuggestion}
        didYouMeanResultCount={didYouMeanResultCount}
        hasStaticEmptySearchResults={hasStaticEmptySearchResults}
        broadened={broadened}
        broadenedSearchType={broadenedSearchType}
        searchType={searchType}
        showExternalSearchLink={showExternalSearchLink}
        customEdit={customEdit}
        suppress={suppress}
        rssURL={rssURL}
        orderedSearchTypes={orderedSearchTypes}
        locked={router.query.locked === 'true'}
        didNotFindOptions={didNotFindOptions}
        singleBranch={singleBranch}
        shelfName={shelfName}
        library={library}
      />
    );
  }
}

EmptySearchResultContainer.propTypes = {
  query: PropTypes.string,
  titleKey: PropTypes.string,
  activeFilters: ImmutablePropTypes.mapOf(PropTypes.object).isRequired,
  chatWidgets: ImmutablePropTypes.mapOf(PropTypes.object),
  currentUser: ImmutablePropTypes.map,
  orderedSearchTypes: ImmutablePropTypes.list,
  didYouMeanQuerySuggestion: PropTypes.string,
  didYouMeanResultCount: PropTypes.number,
  hasStaticEmptySearchResults: PropTypes.bool.isRequired,
  searchType: PropTypes.string,
  broadened: PropTypes.bool,
  broadenedSearchType: PropTypes.string,
  rssURL: PropTypes.string,
  customEdit: PropTypes.bool,
  shelfName: PropTypes.string,
  suppress: PropTypes.bool,
  didNotFindOptions: didNotFindOptionsShape,
  singleBranch: PropTypes.bool,
  library: libraryShape,
  router: routerShape.isRequired,
  showExternalSearchLink: PropTypes.bool
};

const mapStateToProps = state => {
  const catalogSearch = state.getIn(['search', 'catalogSearch']);
  const library = currentLibrarySelector(state);

  return {
    broadened: catalogSearch.get('broadened'),
    broadenedSearchType: catalogSearch.get('broadenedSearchType'),
    searchType: catalogSearch.get('searchType'),
    locked: catalogSearch.get('locked'),
    query: catalogSearch.get('query', ''),
    activeFilters: catalogSearch.get('activeFilters'),
    chatWidgets: library.get('chatWidgets'),
    currentUser: currentUserSelector(state),
    didYouMeanQuerySuggestion: catalogSearch.get('didYouMeanQuerySuggestion'),
    didYouMeanResultCount: catalogSearch.get('didYouMeanResultCount'),
    hasStaticEmptySearchResults: !!state.getIn(['localization', 'messages', 'static_empty_search_results_page']),
    showExternalSearchLink: library.get('showExternalSearchLink'),
    suppress: catalogSearch.get('suppress'),
    rssURL: catalogSearch.get('rssURL'),
    customEdit: catalogSearch.get('custom_edit'),
    titleKey: catalogSearch.get('title_key'),
    orderedSearchTypes: library.get('orderedSearchTypes', Immutable.List()),
    didNotFindOptions: library.get('didNotFindOptions'),
    singleBranch: library.get('singleBranch'),
    shelfName: catalogSearch.get('shelfName'),
    library
  };
};

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EmptySearchResultContainer));
